import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

const Ctx = createContext({});

// Disponibilité du contenu par collection : permet de masquer dynamiquement
// les rubriques vides (menu, sections, tuiles) tant qu'aucun contenu réel n'existe.
export function ContentAvailabilityProvider({ children }) {
  const { data } = useQuery({
    queryKey: ["content-availability"],
    queryFn: () => api.get("/content-availability").then((r) => r.data),
    staleTime: 60_000,
  });
  return <Ctx.Provider value={data || {}}>{children}</Ctx.Provider>;
}

export const useAvailability = () => useContext(Ctx);
